module.exports = __webpack_public_path__ + "img/alipay.a738bea9.svg";